export default function JUMonogram({ size = 44, light = true }) {
    const ring = "#C9A66B";
    const text = light ? "#F5F0E6" : "#152340";
    const bg = light ? "#152340" : "none";
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            role="img"
            aria-label="Journeys Unscripted monogram"
            data-testid="ju-monogram"
        >
            {light && <circle cx="32" cy="32" r="31" fill={bg} />}
            <circle cx="32" cy="32" r="28.5" fill="none" stroke={ring} strokeWidth="1.6" />
            <circle cx="32" cy="32" r="24.5" fill="none" stroke={ring} strokeWidth="0.7" />
            <text
                x="33"
                y="40.5"
                textAnchor="middle"
                fontFamily="Lora, Georgia, serif"
                fontStyle="italic"
                fontSize="23"
                fill={text}
                letterSpacing="0.5"
            >
                JU
            </text>
        </svg>
    );
}
